import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

/**
 * Called when there is a change in the MergedViewAvailability enabled option
 */

export default mutatorAction('updateMergedViewAvailabilityCurrentState', function(
    mergedViewEnabledAccountInitial: string
) {
    let optionState = getStore();
    optionState.mergedViewEnabledAccountCurrent = mergedViewEnabledAccountInitial;
});
